
  // Ankündigungs-Slider: rotiert automatisch & nahtlos durch die Vorteile
  (function(){
    const track=document.getElementById('annTrack');
    if(!track)return;
    const slideH=40, real=track.children.length-1; // letzter = Duplikat des ersten
    let i=0;
    setInterval(()=>{
      i++;
      track.style.transition='transform .6s cubic-bezier(.4,0,.2,1)';
      track.style.transform='translateY(-'+(i*slideH)+'px)';
      if(i===real){ // beim Duplikat angekommen → unsichtbar auf Position 0 zurücksetzen
        setTimeout(()=>{
          track.style.transition='none';
          track.style.transform='translateY(0)';
          i=0;
        },640);
      }
    },2800);
  })();

  // Premium-Sternenfeld: additives Leuchten, Nebel-Schleier, Parallax-Tiefe, organisches Funkeln
  const TINTS=[[255,255,255],[212,226,255],[178,202,255],[255,240,214],[255,222,198]];
  function makeStar(tint){
    const S=96,s=document.createElement('canvas');s.width=s.height=S;
    const ctx=s.getContext('2d'),c=S/2,[R,G,B]=tint;
    const g=ctx.createRadialGradient(c,c,0,c,c,c);
    g.addColorStop(0,'rgba(255,255,255,1)');
    g.addColorStop(.10,`rgba(${R},${G},${B},.92)`);
    g.addColorStop(.24,`rgba(${R},${G},${B},.30)`);
    g.addColorStop(.55,`rgba(${R},${G},${B},.06)`);
    g.addColorStop(1,`rgba(${R},${G},${B},0)`);
    ctx.fillStyle=g;ctx.beginPath();ctx.arc(c,c,c,0,7);ctx.fill();
    return s;
  }
  function makeSpiked(tint){
    const S=170,s=document.createElement('canvas');s.width=s.height=S;
    const ctx=s.getContext('2d'),c=S/2,[R,G,B]=tint;
    const g=ctx.createRadialGradient(c,c,0,c,c,S*0.17);
    g.addColorStop(0,'rgba(255,255,255,1)');
    g.addColorStop(.4,`rgba(${R},${G},${B},.55)`);
    g.addColorStop(1,`rgba(${R},${G},${B},0)`);
    ctx.fillStyle=g;ctx.beginPath();ctx.arc(c,c,S*0.17,0,7);ctx.fill();
    function spike(len,alpha,angle){
      ctx.save();ctx.translate(c,c);ctx.rotate(angle);
      const lg=ctx.createLinearGradient(0,-len,0,len);
      lg.addColorStop(0,'rgba(255,255,255,0)');
      lg.addColorStop(.5,`rgba(255,255,255,${alpha})`);
      lg.addColorStop(1,'rgba(255,255,255,0)');
      ctx.strokeStyle=lg;ctx.lineWidth=1.3;ctx.beginPath();ctx.moveTo(0,-len);ctx.lineTo(0,len);ctx.stroke();
      ctx.restore();
    }
    spike(c-6,.9,0);spike(c-6,.9,Math.PI/2);
    spike(c*0.5,.3,Math.PI/4);spike(c*0.5,.3,-Math.PI/4);
    return s;
  }
  function makeNebula(rgb,alpha){
    const S=512,s=document.createElement('canvas');s.width=s.height=S;
    const ctx=s.getContext('2d'),[R,G,B]=rgb;
    for(let k=0;k<3;k++){
      const cx=S/2+(Math.random()-.5)*S*.42,cy=S/2+(Math.random()-.5)*S*.42,r=S*(.28+Math.random()*.22);
      const g=ctx.createRadialGradient(cx,cy,0,cx,cy,r);
      g.addColorStop(0,`rgba(${R},${G},${B},${alpha})`);g.addColorStop(1,`rgba(${R},${G},${B},0)`);
      ctx.fillStyle=g;ctx.fillRect(0,0,S,S);
    }
    ctx.globalCompositeOperation='destination-in';const m=ctx.createRadialGradient(S/2,S/2,0,S/2,S/2,S/2);m.addColorStop(0,'rgba(0,0,0,1)');m.addColorStop(.7,'rgba(0,0,0,1)');m.addColorStop(1,'rgba(0,0,0,0)');ctx.fillStyle=m;ctx.fillRect(0,0,S,S);
    return s;
  }
  const STAR=TINTS.map(makeStar),SPIKED=TINTS.map(makeSpiked);
  const NEBS=[makeNebula([60,105,225],.12),makeNebula([135,95,225],.10),makeNebula([38,78,185],.11)];

  function starfield(canvas,count){
    const c=canvas,ctx=c.getContext('2d');
    const DPR=()=>Math.min(window.devicePixelRatio||1,2);
    function size(){const w=c.offsetWidth,h=c.offsetHeight;if(!w||!h)return;const d=DPR();c.width=Math.round(w*d);c.height=Math.round(h*d)}
    size();
    const clouds=[];
    for(let i=0;i<3;i++)clouds.push({neb:NEBS[i%NEBS.length],x:Math.random(),y:Math.random(),
      r:1.1+Math.random()*.6,dx:(Math.random()-.5)*2e-5,dy:(Math.random()-.5)*1.4e-5});
    const stars=[];
    for(let i=0;i<count;i++){
      const depth=Math.random();                 // 0 fern … 1 nah
      const bright=Math.random()>.93;
      stars.push({
        x:Math.random(),y:Math.random(),
        tint:Math.random()<.7?(Math.random()<.5?1:2):(Math.random()*TINTS.length|0),
        bright,
        base:bright?(14+Math.random()*14):(3+depth*7+Math.pow(Math.random(),2)*5),
        maxA:bright?(.72+Math.random()*.28):(.22+depth*.46),
        a:Math.random()*6.283,
        tw:.004+Math.random()*.01,               // Funkel-Tempo
        twAmt:bright?(.35+Math.random()*.3):(.2+Math.random()*.45), // Funkel-Stärke
        drift:4e-6+depth*1.8e-5                   // Parallax-Drift
      });
    }
    let meteor=null,nextMeteor=performance.now()+5000+Math.random()*7000;
    function draw(now){
      const W=c.width,H=c.height,d=DPR();
      ctx.clearRect(0,0,W,H);
      ctx.globalCompositeOperation='lighter';
      for(const cl of clouds){
        cl.x+=cl.dx;cl.y+=cl.dy;
        const m=Math.max(W,H)*cl.r;
        ctx.globalAlpha=1;ctx.drawImage(cl.neb,cl.x*W-m/2,cl.y*H-m/2,m,m);
      }
      for(const st of stars){
        st.a+=st.tw;st.x+=st.drift;if(st.x>1.02)st.x-=1.04;
        const tw=(Math.sin(st.a)+1)/2;
        ctx.globalAlpha=Math.min(st.maxA*(1-st.twAmt+st.twAmt*tw),1);
        const sz=st.base*d*(st.bright?(.9+tw*.25):1);
        ctx.drawImage(st.bright?SPIKED[st.tint]:STAR[st.tint],st.x*W-sz/2,st.y*H-sz/2,sz,sz);
      }
      if(!meteor&&now>nextMeteor){
        const fromLeft=Math.random()<.5;
        meteor={x:fromLeft?-.05:1.05,y:Math.random()*.35+.05,
          vx:(fromLeft?1:-1)*(.009+Math.random()*.004),vy:.0035+Math.random()*.002,life:1};
      }
      if(meteor){
        meteor.x+=meteor.vx;meteor.y+=meteor.vy;meteor.life-=.014;
        const mx=meteor.x*W,my=meteor.y*H,tx=mx-meteor.vx*W*11,ty=my-meteor.vy*H*11;
        const lg=ctx.createLinearGradient(mx,my,tx,ty);
        lg.addColorStop(0,`rgba(255,255,255,${.9*meteor.life})`);
        lg.addColorStop(.4,`rgba(190,210,255,${.32*meteor.life})`);
        lg.addColorStop(1,'rgba(160,190,255,0)');
        ctx.globalAlpha=1;ctx.strokeStyle=lg;ctx.lineWidth=1.5*d;ctx.lineCap='round';
        ctx.beginPath();ctx.moveTo(mx,my);ctx.lineTo(tx,ty);ctx.stroke();
        const ms=12*d*meteor.life;
        ctx.globalAlpha=meteor.life;ctx.drawImage(STAR[0],mx-ms/2,my-ms/2,ms,ms);
        if(meteor.life<=0||meteor.x<-.2||meteor.x>1.2){meteor=null;nextMeteor=now+7000+Math.random()*10000}
      }
      ctx.globalCompositeOperation='source-over';ctx.globalAlpha=1;
    }
    function frame(now){draw(now);requestAnimationFrame(frame)}
    requestAnimationFrame(frame);
    // Bei Größenänderung: Buffer sofort anpassen UND sofort neu zeichnen → kein Verzerren
    window.addEventListener('resize',()=>{size();draw(performance.now())});
  }
  ['stars','stars2'].forEach(id=>{const e=document.getElementById(id);if(e)starfield(e,190)});

  // Autoplay-Absicherung für Loop-Videos: muted per JS setzen (Browser-Quirk)
  // und beim Sichtbarwerden starten
  const loopVids=document.querySelectorAll('video[autoplay]');
  loopVids.forEach(v=>{v.muted=true;v.play().catch(()=>{})});
  const vio=new IntersectionObserver(es=>es.forEach(e=>{
    if(e.isIntersecting&&e.target.paused)e.target.play().catch(()=>{});
  }),{threshold:.15});
  loopVids.forEach(v=>vio.observe(v));
  document.addEventListener('click',()=>{
    loopVids.forEach(v=>{if(v.paused)v.play().catch(()=>{})});
  },{once:true});

  // Video-Platzhalter solange Dateien fehlen
  document.querySelectorAll('.vid-card video').forEach(v=>{
    v.addEventListener('error',()=>{
      const ph=document.createElement('div');
      ph.className='vid-ph';
      ph.innerHTML='<div class="ph-ico">▷</div><div>'+v.dataset.ph+'</div>';
      v.replaceWith(ph);
    });
  });

  // FAQ accordion (tastaturbedienbar: Frage ist ein echter Knopf mit aria-expanded)
document.querySelectorAll('.faq-item').forEach(it=>{
  const q = it.querySelector('.faq-q');
  if(!q) return;
  q.addEventListener('click',()=>{
    const offen = it.classList.toggle('open');
    q.setAttribute('aria-expanded', offen ? 'true' : 'false');
  });
});

// Swatch select
  document.querySelectorAll('.swatches').forEach(group=>{
    group.querySelectorAll('.swatch').forEach(s=>{
      s.addEventListener('click',()=>{group.querySelectorAll('.swatch').forEach(x=>x.classList.remove('active'));s.classList.add('active')});
    });
  });

  // ===== Fahrzeug-Konfigurator (Shopify: Line-Item-Properties + echte Varianten) =====
  const fmtEUR = c => new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format(c/100);

  const drawerEl=document.getElementById('cartDrawer'),drawerBackdrop=document.getElementById('cartBackdrop');
  function openDrawerUI(){if(!drawerEl)return;drawerEl.classList.add('open');drawerBackdrop.classList.add('show');document.body.style.overflow='hidden'}
  function closeDrawerUI(){if(!drawerEl)return;drawerEl.classList.remove('open');drawerBackdrop.classList.remove('show');document.body.style.overflow=''}

  async function fetchCart(){return (await fetch('/cart.js')).json()}
  async function renderCart(){
    if(!drawerEl)return;
    const cart=await fetchCart();
    const wrap=document.getElementById('cartItems');
    const upsell=document.getElementById('upsell');
    const upsellId=upsell?+upsell.dataset.variantId:0;
    let html='';
    if(!cart.items.length)html='<p style="color:var(--txt-dim);padding:20px 0">Dein Warenkorb ist leer.</p>';
    for(const it of cart.items){
      const props=it.properties?Object.values(it.properties).filter(Boolean).join(' · '):'';
      html+='<div class="cart-item">'
        +(it.image?'<img src="'+it.image.replace(/(\.[a-z]+)(\?|$)/,'_120x$1$2')+'" alt="">':'<img src="" alt="" style="opacity:0">')
        +'<div class="ci-info"><b>'+it.product_title+(it.variant_title&&it.variant_title!=='Default Title'?' – '+it.variant_title:'')+'</b>'
        +(props?'<small>'+props+'</small>':'')
        +'<div class="ci-foot"><span class="ci-price">'+fmtEUR(it.final_line_price)+'</span>'
        +'<button class="ci-remove" data-key="'+it.key+'">Entfernen</button></div></div></div>';
    }
    wrap.innerHTML=html;
    if(window.clCartSummary){window.clCartSummary(cart);}else{document.getElementById('cartTotal').textContent=fmtEUR(cart.total_price);}
    {const _cc=document.getElementById('cartCount');if(_cc){_cc.textContent=cart.item_count;_cc.style.display=cart.item_count>0?'flex':'none';}}
    if(upsell)upsell.style.display=cart.items.some(i=>i.variant_id===upsellId)?'none':'block';
  }
  if(drawerEl){
    document.getElementById('cartClose').addEventListener('click',closeDrawerUI);
    document.getElementById('cartContinue').addEventListener('click',closeDrawerUI);
    drawerBackdrop.addEventListener('click',closeDrawerUI);
    document.addEventListener('keydown',e=>{if(e.key==='Escape')closeDrawerUI()});
    const cartOpenBtn=document.getElementById('cartOpen');
if(cartOpenBtn)cartOpenBtn.addEventListener('click',async e=>{e.preventDefault();await renderCart();openDrawerUI();});
fetch('/cart.js').then(r=>r.json()).then(c=>{const _cc=document.getElementById('cartCount');if(_cc){_cc.textContent=c.item_count;_cc.style.display=c.item_count>0?'flex':'none';}}).catch(()=>{});
    document.getElementById('cartItems').addEventListener('click',async e=>{
      const key=e.target.dataset.key;
      if(!key)return;
      e.target.textContent='…';
      await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:0})});
      renderCart();
    });
    const upsellBtn=document.getElementById('upsellAdd');
    if(upsellBtn)upsellBtn.addEventListener('click',async()=>{
      upsellBtn.textContent='…';
      await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:+document.getElementById('upsell').dataset.variantId,quantity:1})});
      upsellBtn.textContent='+ Hinzufügen';
      renderCart();
    });
  }

  const cfgRoot=document.getElementById('cfg-brand');
  if(cfgRoot && typeof VEHICLES!=='undefined'){
    function fill(sel,items,ph){
      sel.innerHTML='';
      const o=document.createElement('option');o.value='';o.textContent=ph;sel.appendChild(o);
      for(const it of items){const e=document.createElement('option');e.value=it;e.textContent=it;sel.appendChild(e)}
    }
    const brandIn=document.getElementById('cfg-brand'),modelIn=document.getElementById('cfg-model'),
          yearSel=document.getElementById('cfg-year'),bodySel=document.getElementById('cfg-body'),
          nf=document.getElementById('cfg-notfound'),free=document.getElementById('cfg-free'),
          freeIn=document.getElementById('cfg-freetext'),
          confirmBox=document.getElementById('cfg-confirm'),confirmTxt=document.getElementById('cfg-confirm-txt'),
          msg=document.getElementById('cfg-msg'),cta=document.getElementById('cfg-cta');
    fill(yearSel,VEHICLES.years,'Baujahr wählen…');
    fill(bodySel,VEHICLES.bodies,'Form wählen…');

    function makeCombo(comboEl){
      const input=comboEl.querySelector('.combo-input');
      const panel=comboEl.querySelector('.combo-panel');
      let items=[],onSel=()=>{};
      function render(filter){
        const f=(filter||'').toLowerCase().trim();
        const list=f?items.filter(it=>it.toLowerCase().includes(f)):items;
        panel.innerHTML='';
        if(!list.length){const e=document.createElement('div');e.className='combo-empty';e.textContent='Keine Treffer';panel.appendChild(e);return}
        list.forEach(it=>{
          const o=document.createElement('div');o.className='combo-opt';o.textContent=it;
          o.addEventListener('mousedown',ev=>{ev.preventDefault();input.value=it;close();onSel(it)});
          panel.appendChild(o);
        });
      }
      function open(){if(input.disabled)return;render('');comboEl.classList.add('open')}
      function close(){comboEl.classList.remove('open')}
      input.addEventListener('focus',open);
      input.addEventListener('click',open);
      input.addEventListener('input',()=>{comboEl.classList.add('open');render(input.value);onSel(input.value)});
      document.addEventListener('click',e=>{if(!comboEl.contains(e.target))close()});
      return {setItems(a){items=a},onSelect(fn){onSel=fn},enable(b){input.disabled=!b;if(!b)input.value=''}};
    }
    const brandCombo=makeCombo(document.getElementById('combo-brand'));
    const modelCombo=makeCombo(document.getElementById('combo-model'));
    brandCombo.setItems(VEHICLES.brands);

    const brandValid=()=>!!VEHICLES.models[brandIn.value];
    const modelValid=()=>brandValid()&&VEHICLES.models[brandIn.value].includes(modelIn.value);
    const freeValid=()=>nf.checked&&freeIn.value.trim().length>3;
    const allValid=()=>(brandValid()&&modelValid()&&yearSel.value&&bodySel.value)||freeValid();

    brandCombo.onSelect(()=>{
      modelIn.value='';
      if(brandValid()){
        modelCombo.enable(true);modelIn.placeholder='Wählen oder tippen…';
        modelCombo.setItems(VEHICLES.models[brandIn.value]);
      }else{
        modelCombo.enable(false);modelIn.placeholder='Erst Marke wählen';modelCombo.setItems([]);
      }
      update();
    });
    modelCombo.onSelect(update);
    nf.addEventListener('change',()=>{free.classList.toggle('show',nf.checked);update()});
    [yearSel,bodySel,freeIn].forEach(el=>el.addEventListener('input',update));

    function update(){
      if(freeValid()){
        confirmTxt.textContent='Wird maßgefertigt für: '+freeIn.value.trim();
        confirmBox.classList.add('show');
      }else if(brandValid()&&modelValid()&&yearSel.value){
        confirmTxt.textContent='Wird maßgefertigt für: '+brandIn.value+' '+modelIn.value
          +(bodySel.value?' ('+bodySel.value+')':'')+', Baujahr '+yearSel.value;
        confirmBox.classList.add('show');
      }else{
        confirmBox.classList.remove('show');
      }
      if(allValid()){
        msg.style.display='none';
        [brandIn,modelIn,yearSel,bodySel].forEach(el=>el.classList.remove('invalid'));
      }
    }

    // Set-Größe = echte Shopify-Varianten
    const priceEl=document.querySelector('#buy .price'),rateEl=document.getElementById('cfg-rate');
    let activeSwatch=document.querySelector('#cfg-sets .swatch.active')||document.querySelector('#cfg-sets .swatch');
    function applyVariant(s){
      if(!s)return;
      const cents=+s.dataset.price;
      cta.textContent='In den Warenkorb · '+fmtEUR(cents);
      if(priceEl)priceEl.textContent=fmtEUR(cents);
      if(rateEl)rateEl.textContent=fmtEUR(Math.round(cents/3));
      const sb=document.querySelector('.sticky-l small');
      if(sb)sb.textContent=fmtEUR(cents)+' · inkl. Fernbedienung';
    }
    document.querySelectorAll('#cfg-sets .swatch').forEach(s=>{
      s.addEventListener('click',()=>{activeSwatch=s;applyVariant(s)});
    });
    applyVariant(activeSwatch);

    cta.addEventListener('click',async e=>{
      e.preventDefault();
      if(!allValid()){
        msg.textContent='Bitte vervollständige deine Fahrzeugdaten – oder nutze „Fahrzeug nicht gefunden?" und trage dein Auto als Text ein.';
        msg.style.display='block';
        if(!freeValid()){
          brandIn.classList.toggle('invalid',!brandValid());
          modelIn.classList.toggle('invalid',!modelValid());
          yearSel.classList.toggle('invalid',!yearSel.value);
          bodySel.classList.toggle('invalid',!bodySel.value);
        }
        return;
      }
      const props={};
      if(freeValid()){props['Fahrzeugdaten']=freeIn.value.trim()}
      else{
        props['Automarke']=brandIn.value;props['Modell']=modelIn.value;
        props['Baujahr']=yearSel.value;props['Karosserieform']=bodySel.value;
      }
      const old=cta.textContent;cta.textContent='Wird hinzugefügt…';
      try{
        const res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({id:+activeSwatch.dataset.id,quantity:1,properties:props})});
        if(!res.ok)throw new Error('add failed');
        await renderCart();openDrawerUI();
      }catch(err){
        msg.textContent='Konnte nicht zum Warenkorb hinzufügen. Bitte lade die Seite neu und versuche es erneut.';
        msg.style.display='block';
      }
      cta.textContent=old;
    });
  }

  // ===== Scroll-Effekte: 3D-Headline + Sticky-Bar =====
  const bar=document.getElementById('stickyBar'),heroH1=document.querySelector('.hero h1'),
        heroEl=document.querySelector('.hero'),buyEl=document.getElementById('buy');
  function onScroll(){
    const vh=window.innerHeight;
    if(heroEl&&heroH1){
      const top=heroEl.getBoundingClientRect().top;
      const p=Math.min(Math.max(-top/(vh*0.75),0),1);
      heroH1.style.transform='translateY('+(p*-46).toFixed(1)+'px) rotateX('+(p*32).toFixed(2)+'deg) scale('+(1-p*0.16).toFixed(3)+')';
      heroH1.style.opacity=(1-p*0.95).toFixed(3);
      heroH1.style.filter='blur('+(p*4).toFixed(1)+'px)';
    }
    if(bar&&buyEl){
      const buyTop=buyEl.getBoundingClientRect().top;
      const past=heroEl?heroEl.getBoundingClientRect().top<-300:window.scrollY>500;
      if(past&&buyTop>400)bar.classList.add('show');else bar.classList.remove('show');
    }
  }
  window.addEventListener('scroll',onScroll,{passive:true});
  document.addEventListener('scroll',onScroll,{passive:true,capture:true});
  onScroll();
// SkyClean Vorher-Nachher-Regler. Lesbare Fassung mit Kommentaren: Carlumina/konfigurator-original/skyclean-regler-in-app-js.js
(function(){var q=document.querySelector('script[src*="/assets/app.js"]');var B=q?q.src.split('app.js')[0]:'';function bau(){if(location.pathname.indexOf('skyclean')<0)return;var a=document.querySelector('#buy .buy-perks')||document.querySelector('#buy .buy-info');if(!a||document.getElementById('sc-regler'))return;var b=document.createElement('div');b.className='sc-regler-block';b.innerHTML='<div class="opt-label">Vorher und nachher</div><p class="sc-unter">Zieh den Regler und sieh den Unterschied: gleicher Sitz, einmal gesaugt.</p><div class="sc-regler" id="sc-regler"><img class="sc-bild" src="'+B+'skyclean-vergleich-ohne.jpg" alt="Autositz mit Staub und Schmutz, vor dem Saugen" draggable="false"><div class="sc-schnitt" id="sc-schnitt"><img class="sc-bild" src="'+B+'skyclean-vergleich-mit.jpg" alt="Derselbe Autositz nach dem Saugen mit dem SkyClean" draggable="false"></div><span class="sc-marke" id="sc-marke"><i></i></span><span class="sc-schild sc-links">ohne SkyClean</span><span class="sc-schild sc-rechts">mit SkyClean</span><input type="range" class="sc-schieber" id="sc-schieber" min="0" max="100" value="50" aria-label="Vergleich zwischen ungesaugtem und gesaugtem Sitz"></div>';a.parentNode.insertBefore(b,a);var f=b.querySelector('#sc-regler'),c=b.querySelector('#sc-schnitt'),m=b.querySelector('#sc-marke'),s=b.querySelector('#sc-schieber');function setze(w){c.style.setProperty('--sc-w',w+'%');m.style.left=w+'%';}s.addEventListener('input',function(){setze(this.value);});function pos(x){var r=f.getBoundingClientRect();var w=Math.max(0,Math.min(100,(x-r.left)/r.width*100));s.value=w;setze(w);}var z=false;f.addEventListener('pointerdown',function(e){z=true;pos(e.clientX);f.setPointerCapture(e.pointerId);});f.addEventListener('pointermove',function(e){if(z)pos(e.clientX);});f.addEventListener('pointerup',function(){z=false;});f.addEventListener('pointercancel',function(){z=false;});setze(50);}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bau);else bau();})();
// SkyMats Vorher-Nachher-Regler in der Kaufbox. Lesbare Fassung mit Kommentaren: Carlumina/konfigurator-original/skymats-regler-in-app-js.js
(function(){var B='https://cdn.shopify.com/s/files/1/0942/4820/6722/files/';var F=[['Violett','#8b5cf6'],['Eisblau','#5b9dff'],['Türkis','#2fd6c8'],['Pink','#f472b6'],['Rot','#ef4444']];function bau(){var pay=document.querySelector('#buy .bx-pay');var cfg=document.querySelector('#buy .cfg-grid');if(!pay||!cfg||document.getElementById('sm-regler'))return;var b=document.createElement('div');b.className='sc-regler-block';b.innerHTML='<div class="opt-label">Vorher und nachher</div><p class="sc-unter">Zieh den Regler und sieh den Unterschied.</p><div class="sc-regler" id="sm-regler"><img class="sc-bild" src="'+B+'skymats-vergleich-ohne.webp?width=1200" alt="Fussraum ohne SkyMats, dunkel und unbeleuchtet" draggable="false"><div class="sc-schnitt" id="sm-schnitt"><img class="sc-bild sm-mit sm-f1" id="sm-mit" src="'+B+'skymats-vergleich-mit.webp?width=1200" alt="Derselbe Fussraum mit beleuchteten SkyMats" draggable="false"></div><span class="sc-marke" id="sm-marke"><i></i></span><span class="sc-schild sc-links">ohne SkyMats</span><span class="sc-schild sc-rechts">mit SkyMats</span><input type="range" class="sc-schieber" id="sm-schieber" min="0" max="100" value="50" aria-label="Vergleich ohne und mit SkyMats"></div><div class="sm-farben" id="sm-farben"><span class="sm-titel">Deine Wunschfarbe: <b id="sm-name">Violett</b></span></div><p class="sm-hinweis">Farbsimulation zur Veranschaulichung. Der echte Farbton kann je nach Auto abweichen.</p>';pay.parentNode.insertBefore(b,pay.nextSibling);var reihe=b.querySelector('#sm-farben'),mit=b.querySelector('#sm-mit'),name=b.querySelector('#sm-name');F.forEach(function(f,i){var k=document.createElement('button');k.type='button';k.className='sm-farbe'+(i?'':' aktiv');k.style.background=f[1];k.title=f[0];k.setAttribute('aria-label',f[0]);k.addEventListener('click',function(){reihe.querySelectorAll('.sm-farbe').forEach(function(x){x.classList.remove('aktiv');});k.classList.add('aktiv');mit.className='sc-bild sm-mit sm-f'+(i+1);b.querySelector('#sm-regler').firstElementChild.className='sc-bild sm-mit sm-f'+(i+1);name.textContent=f[0];});reihe.appendChild(k);});var f2=b.querySelector('#sm-regler'),c=b.querySelector('#sm-schnitt'),m=b.querySelector('#sm-marke'),s=b.querySelector('#sm-schieber');function setze(w){c.style.setProperty('--sc-w',w+'%');m.style.left=w+'%';}s.addEventListener('input',function(){setze(this.value);});function pos(x){var r=f2.getBoundingClientRect();var w=Math.max(0,Math.min(100,(x-r.left)/r.width*100));s.value=w;setze(w);}var z=false;f2.addEventListener('pointerdown',function(e){z=true;pos(e.clientX);f2.setPointerCapture(e.pointerId);});f2.addEventListener('pointermove',function(e){if(z)pos(e.clientX);});f2.addEventListener('pointerup',function(){z=false;});f2.addEventListener('pointercancel',function(){z=false;});setze(50);}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bau);else bau();})();